exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.audit_buttons {\n  margin-top: 50px;\n}\n.el-table .warning-row {\n  background: oldlace;\n}\n", ""]);

// exports
